import * as t from 'io-ts';

import type { SelectClearableDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';
import type { Hierarchy } from '../../../services';

export interface HierarchyIdSettingDefinition extends SelectClearableDefinition {
    key: 'HIERARCHY_ID';
    options: Array<{ key: string; label: string } & Hierarchy>;
}

const definition: HierarchyIdSettingDefinition = {
    key: 'HIERARCHY_ID',
    type: 'SelectClearable',
    label: 'Hierarchy id',
    value: null,
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.union([t.string, t.null]));

export const codec = specSettingsInterface.input;

export const HierarchyIdSettingDefinition = define({
    key: 'HIERARCHY_ID',
    label: 'hierarchyId',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.hierarchyId),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.hierarchyId),
    applySettingDependency: props => {
        const { currentDefinition, diff } = props;
        const internalKeyChanged = !!diff.INTERNAL_KEY;
        const currentHierarchy = diff.HIERARCHY_ID?.current;

        if (!internalKeyChanged) return;

        const isValueStillValid = currentDefinition.options.some(
            ({ key }) => key === currentHierarchy,
        );

        return isValueStillValid ? undefined : { value: null };
    },
});
